import styled from 'vue-styled-components'

export const Card = styled.div`
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 2px 8px rgba(56,60,74,0.15);
`